import React from 'react';
import { exclamation } from '@amzn/storm-ui-icons';
import { ActivationAttribute } from '@amzn/storm-ui-page-header';
import { Activation } from '../types';
import { useActivationData } from './ajaxPutActivationInfo';
import { APIFailureIcon } from './styles';
import { SnackbarContainer, ToastBanner } from '../../ToastBanner/ToastBanner';
import { BANNER_TYPE } from '../../../../../app/slice';
import { usePageHeaderBundle } from 'src/providers/PantherLocalizationProvider';
import { chromeComponents } from 'src/constants';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';

export const AttributesActivation: React.VFC<Activation> = ({
  id,
  label,
  offLabel,
  isActive,
  disabled,
  activationAPI,
  apiCallFailureMessage,
  attachedComponent,
  ariaLabel,
  toolTip,
  tooltipPosition,
  disable,
  blockActivationEventName,
}) => {
  const bundle = usePageHeaderBundle();
  const {
    toggled,
    showFailBanner,
    requestFailMessage,
    bannerCloseEvent,
    activationToggleEvent,
    isDisabled,
  } = useActivationData({
    activationAPI,
    id,
    isActive,
    attachedComponent,
    apiCallFailureMessage,
    disabled: !!disabled || !!disable,
    blockActivationEventName: blockActivationEventName || undefined,
  });
  const activationLabel = toggled ? label : (offLabel ?? label);
  if (!activationAPI || !apiCallFailureMessage) return null;

  const apiFailureIcon = (
    <APIFailureIcon
      type={exclamation}
      size="small"
      aria-label={bundle.getMessage(
        'page-header-activation-fail-icon-aria-label',
      )}
      data-ccx-e2e-id="aac-activation-fail-icon"
    />
  );

  const ActivationLabel = () => (
    <>
      {requestFailMessage ? apiFailureIcon : null}
      {activationLabel}
    </>
  );

  return (
    <>
      <ActivationAttribute
        id={id}
        label={<ActivationLabel />}
        offLabel={<ActivationLabel />}
        active={toggled}
        disabled={isDisabled}
        onChange={activationToggleEvent}
        helptipText={toolTip}
        helptipTextPosition={tooltipPosition}
        aria-label={ariaLabel}
        data-ccx-e2e-id={`aac-attribute-${id}`}
        {...getTaktAttributes(id, chromeComponents.HEADER)}
      />
      {!!requestFailMessage && showFailBanner && (
        <SnackbarContainer>
          <ToastBanner
            banner={{
              id: `${id}failureMessage`,
              message: requestFailMessage,
              type: BANNER_TYPE.ERROR,
              withCloseButton: true,
            }}
            bannerClosed={bannerCloseEvent}
            autoClose={true}
          />
        </SnackbarContainer>
      )}
    </>
  );
};
